import * as React from 'react';
import { graphql, Link } from 'gatsby';
import classnames from 'classnames';
import ImageWrapper from 'core/components/ImageWrapper';
import * as styles from './BlogCard.module.scss';
import { BlogCardData } from '../../lib/types';

export type BlogCardProps = JSX.IntrinsicElements['div'] & {
    entry: BlogCardData;
};

export const query = graphql`
    fragment BlogCardData on BlogEntry {
        id
        slug
        excerpt
        title
        content {
            data
            blockType
        }
        image: featuredImage {
            id
            file {
                publicURL
                alt
                mobile: childImageSharp {
                    gatsbyImageData(
                        width: 694
                        height: 300
                        sizes: "calc(100vw - 74px)"
                        transformOptions: { fit: COVER, cropFocus: ENTROPY }
                    )
                }
                desktop: childImageSharp {
                    gatsbyImageData(
                        width: 600
                        height: 300
                        transformOptions: { fit: COVER, cropFocus: ENTROPY }
                        sizes: "(max-width: 1210px) calc(50vw - 42px), 600px"
                    )
                }
            }
        }
    }
`;

function BlogCard({
    entry: { slug, title, excerpt, image },
    className,
    ...props
}: BlogCardProps): React.ReactElement {
    const images = React.useMemo(() => {
        return image?.file;
    }, [image?.file]);

    return (
        <Link
            to={`/blog/${slug}`}
            className={classnames(styles.root, className)}
        >
            <div {...props}>
                <ImageWrapper
                    className={styles.image}
                    alt={image?.file?.alt ?? title}
                    image={images}
                />
                <div className={styles.content}>
                    {/* eslint-disable-next-line react/no-danger */}
                    <h3 dangerouslySetInnerHTML={{ __html: title }} />
                    <p>
                        {/* eslint-disable-next-line react/no-danger */}
                        <span dangerouslySetInnerHTML={{ __html: excerpt }} />
                        <span className={styles.link}>Read more</span>
                    </p>
                </div>
            </div>
        </Link>
    );
}

export default BlogCard;
